module.exports = __webpack_public_path__ + "img/instruction-android-03.646bc7e1.png";